import { render, staticRenderFns } from "./HtLikes.vue?vue&type=template&id=2100a905&scoped=true&"
import script from "./HtLikes.vue?vue&type=script&lang=js&"
export * from "./HtLikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100a905",
  null
  
)

export default component.exports